import Entity from "../entity";
export default class Offer extends Entity<number> {
  courtId: number=0;
  supplierId:number=0;
  isOnSale:boolean=false;
  personNumber:number=1;
  days:number=1;
  notice:string="";
  cancelNotice:string="";
  needInvoice:boolean=false;
  vipReduction:number |string=0;
  cashback:string|number=0;
  cancelDate:number=24;
}
